import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import List from "./list";
import Show from "./show";

interface ShippingOrdersProps extends RouteComponentProps {
    clearParams: (key: string) => void;
}

const ShippingOrders = ({ location, clearParams }: ShippingOrdersProps) => {
    useEffect(() => () => clearParams("shipping-orders"), [clearParams]);

    return (
        <Switch location={location}>
            <Route exact path={paths.shippingOrders} component={List} />
            <Route path={paths.shippingOrdersShow(":id")} component={Show} />
        </Switch>
    );
};

export default ShippingOrders;
